import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export type TimerTriggerButtonProps = Omit<TouchableProps, 'haptic'>;

// Inline button styled like a display, not a chip. Used to wrap timer text
// that doubles as a popover trigger. No background, no border — only an
// active state on press. Caller supplies the rest of the styling because
// the layout context varies (block vs inline, mt-1, etc.).
const BASE = 'block text-left rounded active:bg-soft transition-colors';

export const TimerTriggerButton: React.FC<TimerTriggerButtonProps> = ({ className, ...rest }) => (
  <Touchable haptic="transition" className={className ? `${BASE} ${className}` : BASE} {...rest} />
);
